import Vue from 'vue';
import Vuex from 'vuex';

// partials
import appheader from './modules/partials/appheader';
// Login
import login from './modules/login';
// SignUp
import sign_up from './modules/sign_up';
// Index
import index from './modules/index';
// ImportantMessage
import important_message from './modules/important_message';
// GiftManager
import gift_manager from './modules/gift_manager';
// SaleProduct
import sale_product from './modules/sale_product';
// 會員資料異動
import edit_member from './modules/edit_member';

Vue.use(Vuex);

// action --> commit --> mutation
const store = new Vuex.Store({
  // 嚴格模式，禁止直接修改 state，深度監測狀態樹來檢測不合規的狀態變更
  // 發布模式必須關閉避免性能損失
  strict: process.env.NODE_ENV !== 'production',
  modules: {
    // partials
    appheader,
    // 登入頁面
    login,
    // 綁定頁面
    sign_up,
    // H5首頁頁面
    index,
    // 重要訊息
    important_message,
    // 禮物兌換
    gift_manager,
    // 銷售懶人包
    sale_product,
    // 會員資料異動
    edit_member
  },
  state: {
    // logoutCountdown: process.env.VUE_APP_AUTO_LOGOUT_SECONDS,
    //- 使用者名稱
    userInfo: null,
    //- 載入中
    loading: false,
  },
  actions: {},
  // 只做同步行為，不做非同步行為(非同步在 actions 做)
  // 負責接收 action(commit) 資料並計算邏輯後改變 State
  // 只有 mutation 可以改變 state！
  mutations: {
    setUserInfo(state, data) {
      Vue.set(state, 'userInfo', data);
    },
    loadingHandler(state, BooleanInfo) {
      Vue.set(state, 'loading', BooleanInfo);
    },
  },
  getters: {},
});

export default store;